import ApiInstance from "./ApiInstance";

export interface AssignmentClient {
  id: string;
  email: string;
  name?: string;
  // Duty-of-care flags from the client's intake (booleans only, no content):
  // crisis vangnet fired / client was 16-17 at intake.
  intakeCrisisSignal?: boolean;
  clientIsMinor?: boolean;
}
export interface Assignment {
  id: string;
  // "course" (traject, evt. met module) of "selftest" (reflectie-vragenlijst).
  kind: "course" | "selftest";
  courseSlug?: string;
  courseTitle?: string;
  moduleIndex?: number;
  moduleTitle?: string;
  selfTestSlug?: string;
  selfTestTitle?: string;
  note?: string;
  clientUserId: string;
  createdAt: string;
}

// One appointment in the per-client detail — neutral projection, no health
// content (mirrors AppointmentApi.Appointment but detail-only fields).
export interface ClientAppointment {
  _id: string;
  type: "intro" | "coaching" | "therapy";
  start: string;
  end: string;
  status: string;
}
export interface ClientDetail {
  client: AssignmentClient;
  appointments: ClientAppointment[];
  // Homework THIS psychologist assigned to the client. Never the client's own
  // answers/journal — only what was assigned + the psychologist's own note.
  assignments: Assignment[];
}

class AssignmentApi {
  async list(): Promise<Assignment[]> {
    const { data } = await ApiInstance.getApi().get("/assignments");
    return data.assignments;
  }
  async clients(): Promise<AssignmentClient[]> {
    const { data } = await ApiInstance.getApi().get("/assignments/clients");
    return data.clients;
  }
  async clientDetail(clientUserId: string): Promise<ClientDetail> {
    const { data } = await ApiInstance.getApi().get(`/assignments/clients/${clientUserId}`);
    return data;
  }
  // Either courseSlug (optionally with moduleIndex) or selfTestSlug.
  async create(body: { clientUserId: string; courseSlug?: string; selfTestSlug?: string; moduleIndex?: number; note?: string }): Promise<void> {
    await ApiInstance.getApi().post("/assignments", body);
  }
  async remove(id: string): Promise<void> {
    await ApiInstance.getApi().delete(`/assignments/${id}`);
  }
}

const assignmentApi = new AssignmentApi();
export default assignmentApi;
